export const studentInfo = [
  {
    field: 'image',
    heading: 'Image',
    editable: false,
    column: 1,
    type: "image"
  },
  {
    field: '{firstName} {lastName}',
    heading: 'Full Name',
    editable: false,
    column: 2,
  },
  {
    field: 'year',
    heading: 'Year',
    editable: false,
    column: 1
  },
  {
    field: 'email',
    heading: 'Email Address',
    editable: false,
    column: 2
  },
  {
    field: 'schoolId',
    heading: 'School Id',
    editable: false,
    column: 2
  },
  {
    field: 'phone',
    heading: 'Phone Number',
    editable: false,
    column: 1
  },
  {
    field: 'currentClass',
    heading: 'Class (at time of report)',
    editable: false,
    column: 1
  },
  {
    field: 'currentRoom',
    heading: 'Room (at time of report)',
    editable: false,
    column: 1
  },
  {
    field: 'currentInstructor',
    heading: 'Teacher (at time of report)',
    editable: false,
    column: 2
  },
  {
    // Class schedules (Nov 2026, emergency reports only): a short note when there was no class
    // at the time of the report (or an A/B rotation day made it ambiguous).
    field: 'schedule',
    heading: 'Class note',
    editable: false,
    column: 2
  }
];
